module.exports = __webpack_public_path__ + "public/img/error.47ae5b76.png";